import React, { useState, useEffect, useRef } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import HeaderMenuItems from './Components/HeaderMenuItems';
import Logo from '../../Assets/Icons/Logo.png';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CartIcon from '../../Assets/SVG/cart.svg';
import WishListIcon from '../../Assets/SVG/hearticon.svg';
import useFetch from '../../Utils/CustomHook';
import Avatar from '../../Assets/Icons/Avatar.png';
import { setOpenLocationModal } from '../../Redux/features/StateSlice';
import axiosInstance from 'Utils/Interceptor';
import { Popover, Typography } from '@mui/material';
import { formattedDate, slugify } from 'Utils/Functions';
import { Icon } from '@iconify/react';
import GetHelpModal from 'Components/CommonComponents/Modal/HelpModal';
import helpIcon from 'Assets/SVG/help-icon.svg';
import { MenuList } from './HamburgerMenuList';
import GetACallBackModal from 'Pages/Home/Components/GetACallBackModal';
import UploadPrescriptionModal from 'Components/CommonComponents/Modal/UploadPrescriptionModal';
import { toast } from 'react-toastify';
import defaultProfileImage from "../../Assets/images/default-profile-icon.png"
import maleProfileImage from '../../Assets/images/male-icon.png';
import femaleProfileImage from '../../Assets/images/female-icon.png';
import WhatsappIcon from 'Pages/Home/Components/WhatsappIcon';

const Header = ({ showMenu = true, cartHeader, from }) => {
  const { token } = useSelector((state) => state.login);
  const { cityName } = useSelector((state) => state.location);
  let citySlug = slugify(cityName);
  const dispatch = useDispatch();
  const [browserWidth, setBrowserWidth] = useState(0);
  const [notification, setNotification] = useState();
  const navigation = useNavigate();
  const header = useRef(null);
  const responsiveValue = 1260;
  const { wishListData, cartData } = useSelector(
    (state) => state?.parsistStates
  );
  const { profile } = useSelector((state) => state.login);

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showUploadPreModal, setShowUploadPreModal] = useState(false);
  const [showCallBackModal, setShowCallBackModal] = useState(false);

  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };

  const handleClickModal = () => {
    dispatch(setOpenLocationModal(true));
  };

  const handleChangeModal = () => {
    dispatch(setOpenLocationModal(true))
  }

  const primaryNavList = [
    {
      link: '/',
      name: 'Home'
    },
    { link: '/about-us', name: 'About Us' },
    { link: `/${citySlug}/health-packages`, name: 'Health Packages' },
    { link: `/${citySlug}/blood-tests`, name: 'Blood Tests' }
  ];

  useEffect(() => {
    const updateBrowserWidth = () => {
      if (responsiveValue < window.innerWidth) {
        setBrowserWidth(true);
      } else {
        setBrowserWidth(false);
      }
    };

    // Update tabs wrapper width on initial mount and window resize
    updateBrowserWidth();
    window.addEventListener('resize', updateBrowserWidth);

    return () => {
      window.removeEventListener('resize', updateBrowserWidth);
    };
  }, [browserWidth]);

  useEffect(() => {
    if (isNavbarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup on unmount or modal close
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isNavbarOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (header.current) {
        if (window.scrollY >= 50) {
          header.current.classList.add('fixed-me');
        } else {
          header.current.classList.remove('fixed-me');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    fetchNotification();
    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const homeVisit = () => {
    navigation(`/${citySlug}/book-a-home-visit`);
  };

  const handleImage = () => {
    navigation('/my-profile');
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const fetchNotification = async () => {
    try {
      const { data } = await axiosInstance.get('/api/user/notifications');
      setNotification(data);
    } catch (error) {}
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = anchorEl;
  const id = open ? 'simple-popover' : undefined;

  const handleSeenNotification = async (e) => {
    try {
      await axiosInstance.get(`/api/user/notifications/${e}/seen`);
      fetchNotification();
    } catch (error) {}
  };

  const LabVisit = () => {
    navigation(`/${citySlug}/book-a-lab-visit`);
  };

  const handleNotificationClick = (e) => {
    e?.type === 'MyBooking' && navigation(`/my-booking`);
    e?.type === 'Custom' &&
      e?.notification_details?.type === 'Test' &&
      navigation(`/${citySlug}/blood-tests/${e?.notification_details?.id}`);
    e?.type === 'Custom' &&
      e?.notification_details?.type === 'Package' &&
      navigation(
        `/${citySlug}/health-packages/${e?.notification_details?.service_slug}`
      );
    handleSeenNotification(e.notification_id);
    handleClose();
  };

  return (
    <>
      <header
        className="header
    "
        ref={header}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Navbar
                expand="false"
                className="int-hamburger-menu"
                expanded={isNavbarOpen}
                onToggle={() => setIsNavbarOpen(!isNavbarOpen)}
              >
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Brand>
                  <img
                    alt=""
                    onClick={() => navigation('/')}
                    src={Logo}
                  />
                </Navbar.Brand>

                <div className="deskstop-hamburger">
                  <Navbar.Collapse id="navbarScroll">
                    <Nav className="me-auto ">
                      <div className="hamburger-content">
                        <Link
                          to="/"
                          className="logo-hamburger"
                        >
                          <img
                            alt=""
                            src={Logo}
                          />
                        </Link>
                        <div className="secondary-menu">
                          {MenuList.map((items, index) => (
                            <div
                              key={index}
                              className="primary-menu secondary-menu-items"
                            >
                              {items.map((item, index) => (
                                <div className="menu-items">
                                  {item.onclick ? (
                                    <div
                                      onClick={() => {
                                        item.id === 3 && setShowHelpModal(true);
                                        item.id === 2 &&
                                          setShowCallBackModal(true);
                                        item.id === 1 &&
                                          setShowUploadPreModal(true);
                                        closeNavbar();
                                      }}
                                      className="cursor-pointer"
                                    >
                                      {item.name}
                                    </div>
                                  ) : (
                                    <NavLink
                                      key={index}
                                      onClick={() => closeNavbar()}
                                      to={
                                        item.isloc
                                          ? '/' + citySlug + item.link
                                          : item.link
                                      }
                                      state={{ from: 'Home' }}
                                      className={({ isActive }) =>
                                        `${isActive && 'nav-active'}`
                                      }
                                    >
                                      {item.name}
                                    </NavLink>
                                  )}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Nav>
                  </Navbar.Collapse>
                </div>

                <div className="primary-menu-desktop">
                  <Nav>
                    {showMenu && browserWidth ? (
                      <HeaderMenuItems menuItems={primaryNavList} />
                    ) : null}
                  </Nav>
                </div>

                <div className="login-details">
                  {!token ? (
                    <div className="before-btn-group">
                      <div
                        className="home-visit"
                        onClick={homeVisit}
                      >
                        Book Home Visit
                      </div>
                      {cityName && (
                        <div
                          onClick={handleClickModal}
                          className="header-location"
                        >
                          {cityName}
                        </div>
                      )}

                      <Link
                        to="/login"
                        className="btn btn-md"
                      >
                        <span>Login</span>
                      </Link>
                    </div>
                  ) : (
                    <>
                      <div className="after-login-details">
                        {!cartHeader ? (
                          <>
                            <div
                              className="home-visit"
                              onClick={homeVisit}
                            >
                              Book Home Visit
                            </div>

                            {cityName && (
                              <div
                                onClick={handleClickModal}
                                className="header-location"
                              >
                                {cityName}
                              </div>
                            )}

                            <div
                              onClick={() =>
                                navigation('/wishlist', {
                                  state: { from: from }
                                })
                              }
                              className="wishlist"
                            >
                              {wishListData?.length > 0 && (
                                <div className="wish-text"></div>
                              )}
                              <img
                                alt=""
                                className="cursor-pointer"
                                src={WishListIcon}
                              />
                            </div>

                            <div
                              onClick={() => {
                                if (cartData?.length > 0) {
                                  navigation('/booking?stepper=1');
                                } else {
                                  toast.info(
                                    'Your cart is empty, please add some test/packages'
                                  );
                                }
                              }}
                              className="cart-list"
                            >
                              {cartData?.length > 0 && (
                                <div className="wish-text"></div>
                              )}
                              <img
                                alt=""
                                src={CartIcon}
                              />
                            </div>
                            <Typography
                              onClick={handleClick}
                              aria-describedby={id}
                            >
                              <div className="cart-list">
                                {notification?.data?.some(
                                  (e) => e?.notification_status !== 2
                                ) && <div className="wish-text"></div>}
                                <Icon
                                  color="white"
                                  width={21}
                                  className=""
                                  icon={'iconamoon:notification-fill'}
                                />
                              </div>
                            </Typography>
                          </>
                        ) : (
                          <GetHelpModal>
                            <span className="btn btn-md btn-stroke btn-help need-btn-help">
                              <span>
                                <img
                                  src={helpIcon}
                                  alt=""
                                />
                              </span>
                              <span>Need help</span>
                            </span>
                          </GetHelpModal>
                        )}
                        <div
                          onClick={handleImage}
                          className="profile-item "
                        >
                          <img
                            onError={(item) => (item.target.src = Avatar)}
                            alt=""
                            className="profile-icon"
                            src={
                              profile?.profile_image
                              ? profile?.profile_image
                              : profile?.gender === 'Male'
                              ? maleProfileImage
                              : profile?.gender === 'Female'
                              ? femaleProfileImage
                              : defaultProfileImage
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </Navbar>
            </div>
          </div>
        </div>
        <WhatsappIcon />
      </header>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Typography
          sx={{ p: 2 }}
          color={'#EF7F1A'}
          className="ball-notification-wrapper"
        >
          <div className="ball-notification-container">
            {notification?.data?.map((e) => (
              <div
                onClick={() => handleNotificationClick(e)}
                id="notification-container"
                className={
                  e?.notification_status === 2
                    ? 'notification-unread'
                    : 'notification-read'
                }
              >
                <h6 className="">{e.notification_details.title}</h6>
                <div className="">{e.notification_details.content}</div>
                <div className="">{formattedDate(e?.created_datetime)}</div>
              </div>
            ))}
            {notification?.data?.length === 0 && (
              <div>No notifications detected</div>
            )}
          </div>
        </Typography>
      </Popover>

      {showHelpModal && (
        <GetHelpModal
          open={showHelpModal}
          handleClose={() => setShowHelpModal(false)}
        />
      )}
      {showUploadPreModal && (
        <UploadPrescriptionModal
          open={showUploadPreModal}
          handleClose={() => setShowUploadPreModal(false)}
        />
      )}
      {showCallBackModal && (
        <GetACallBackModal
          open={showCallBackModal}
          handleClose={() => setShowCallBackModal(false)}
        />
      )}
    </>
  );
};

export default Header;
